import { View, StyleSheet, Image } from "@react-pdf/renderer";
import { baseUrl } from "../../../api/config";
import store2 from "store2";

type PdfHeaderProps = { mb?: number };

export const PdfHeader = ({ mb = 50 }: PdfHeaderProps) => (
    <View style={{ alignItems: "center", marginBottom: mb }} fixed>
        <Image
            style={styles.logo}
            src={`${baseUrl}/assets/9f5207ed-3164-4456-a7a2-f06bf845fa1c?access_token=${
                store2.get("auth").access_token
            }`}
        />
    </View>
);

const styles = StyleSheet.create({
    logo: {
        width: 250,
		height: "auto",
		objectFit: "contain",
        alignSelf: "center",
        paddingVertical:1,
    },
})